import { useLanguage } from "../../../i18n/LanguageContext";
import "./door.css";

const text = {
    en: {
        unlocked: "Room 214 unlocked · 0.8s",
        chip: <>Secure digital key · <b>no key card</b></>,
        app: "Smart Key",
        room: "Room 214",
        stay: "3 nights · Check-out Fri",
        near: "Near your door",
        opened: "✓ Door unlocked",
        swipe: "Swipe to open",
    },
    ar: {
        unlocked: "تم فتح الغرفة 214 · 0.8 ث",
        chip: <>مفتاح رقمي آمن · <b>بدون بطاقة</b></>,
        app: "ضياف",
        room: "الغرفة 214",
        stay: "3 ليالٍ · المغادرة الجمعة",
        near: "بالقرب من بابك",
        opened: "✓ تم فتح الباب",
        swipe: "مرّر للفتح",
    },
};

// Phone swipe -> signal -> lock turns green -> door opens into the room. One 8s loop.
const DoorScene = () => {
    const { lang, isRtl } = useLanguage();
    const t = text[lang];
    const dir = isRtl ? "rtl" : "ltr";
    return (
        <>
            <div className="skd-wall"></div>
            <div className="skd-floor"></div>
            <div className="skd-frame"><div className="skd-room"></div></div>
            <div className="skd-spill"></div>
            <div className="skd-door">
                <div className="skd-roomno">214</div>
                <div className="skd-lock">
                    <div className="skd-led"></div>
                    <div className="skd-ring"></div>
                    <div className="skd-ring r2"></div>
                    <div className="skd-pad">• • •</div>
                    <div className="skd-handle"></div>
                </div>
            </div>

            <div className="skd-dot"></div>
            <div className="skd-dot d2"></div>
            <div className="skd-dot d3"></div>

            <div className="skd-toast" dir={dir}><i></i>{t.unlocked}</div>
            <div className="skd-chip" dir={dir}>{t.chip}</div>

            <div className="sk-mobile skd-phone">
                <div className="sk-mobile-screen" dir={dir}>
                    <div className="sk-mobile-label">{t.app}</div>
                    <div className="sk-mobile-heading">{t.room}</div>
                    <div className="skd-stay">{t.stay}</div>
                    <div className="skd-keyicon">
                        <div className="skd-wave"></div>
                        <div className="skd-wave w2"></div>
                        <div className="skd-wave w3"></div>
                        <svg viewBox="0 0 24 24" fill="none" stroke="#0b5f8f" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <circle cx="7.5" cy="15.5" r="4.5" />
                            <path d="M10.7 12.3 21 2" />
                            <path d="m16 7 3 3" />
                            <path d="m19 4 2 2" />
                        </svg>
                    </div>
                    <div className="skd-status"><b className="s1">{t.near}</b><b className="s2">{t.opened}</b></div>
                    <div className="skd-track">
                        <div className="skd-fill"></div>
                        <div className="skd-thumb">›</div>
                        <span>{t.swipe}</span>
                    </div>
                </div>
            </div>
        </>
    )
}
export default DoorScene;
